import { useNavigate } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";
import { ArrowLeft, ScanBarcode, PackagePlus, Package, Truck, Tags, Layers, PackageSearch } from "lucide-react";
import { useTranslation } from "../i18n";
import { isVisible, useHomeModuleVisibility, readUserRole } from "../components/helpers/homeModuleVisibility";
import { useBadgeCounts } from "../hooks/useBadgeCounts";
import "../styles/home.css";

const GoodsInMenu = () => {
    usePageTitle("goods_in");
    const navigate = useNavigate();
    const { t } = useTranslation();

    const userData = window.localStorage.getItem("user");
    const userObject = userData !== null ? JSON.parse(userData) : { permissions: "", warehouse: "" };
    const role = readUserRole();
    const moduleMap = useHomeModuleVisibility(userObject.warehouse);
    const show = (key: string) => isVisible(moduleMap, key, role);

    // Pending / placed pallet badges come precomputed from the server
    // (GET /badges) — no per-page poll of /pallet-receiving/today-count.
    const counts = useBadgeCounts(userObject.warehouse);
    const pendingPallets = counts.palletReceiving.pendingCount;
    const placedPallets = counts.palletReceiving.placedCount;

    return (
        <div className="page-data" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <div className="page-title-bar">
                <h1 className="page-title">{t("goods_in")}</h1>
                <button className="page-back-btn" onClick={() => navigate("/")}>
                    <ArrowLeft size={20} />
                </button>
            </div>
            <div className="home-grid">
                {show("goods_in.inbound") && (
                    <button className="home-card home-card-orange" onClick={() => navigate("/pallet-receiving")}>
                        {pendingPallets > 0 && <span className="home-card-badge">{pendingPallets}</span>}
                        <div className="home-card-icon"><Package size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("pallet_receiving")}</div>
                    </button>
                )}
                {show("goods_in.move") && (
                    <button className="home-card home-card-orange" onClick={() => navigate("/move")}>
                        {placedPallets > 0 && <span className="home-card-badge">{placedPallets}</span>}
                        <div className="home-card-icon"><Truck size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("move")}</div>
                    </button>
                )}
                {show("goods_in.scan_sheet") && (
                    <button className="home-card home-card-orange" onClick={() => navigate("/scansheet")}>
                        <div className="home-card-icon"><ScanBarcode size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("scan_sheet")}</div>
                    </button>
                )}
                {show("goods_in.relabel") && (
                    <button className="home-card home-card-orange" onClick={() => navigate("/relabel")}>
                        <div className="home-card-icon"><Tags size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("relabel")}</div>
                    </button>
                )}
                {show("goods_in.book_in") && (
                    <button className="home-card home-card-orange" onClick={() => navigate("/book-in")}>
                        <div className="home-card-icon"><PackagePlus size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("book_in")}</div>
                    </button>
                )}
                {show("goods_in.pallets") && (
                    <button className="home-card home-card-orange" onClick={() => navigate("/pallets")}>
                        <div className="home-card-icon"><Layers size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("pallets")}</div>
                    </button>
                )}
                {show("goods_in.sku_finder") && (
                    <button className="home-card home-card-orange" onClick={() => navigate("/sku-finder")}>
                        <div className="home-card-icon"><PackageSearch size={48} strokeWidth={1.5} /></div>
                        <div className="home-card-title">{t("sku_finder")}</div>
                    </button>
                )}
            </div>
        </div>
    );
};

export default GoodsInMenu;
